import { getTime, parse, add } from 'date-fns';

const DATE_FORMAT = 'dd-MM-yyyy HH:mm:ss';
export const MOSKOW_OFFSET = -180;

export const resolveDatesForTechnicalWork = (datesString?: string | false) => {
  if (!datesString) return false;

  try {
    const { start, end } = getAndCheckDatesFrom(datesString);

    const clientOffset = new Date().getTimezoneOffset();
    const offset = MOSKOW_OFFSET - clientOffset;

    const startWithOffset = add(start, { minutes: offset });
    const endWithOffset = add(end, { minutes: offset });

    const startWithOffsetNumber = Number(startWithOffset);
    const endWithOffsetNumber = Number(endWithOffset);
    const nowNumber = Number(new Date());

    return nowNumber > startWithOffsetNumber && nowNumber < endWithOffsetNumber;
  } catch {
    return false;
  }
};

export const getAndCheckDatesFrom = (datesString: string) => {
  const datesArr = datesString.split(',');
  if (!datesArr[0] || !datesArr[1])
    throw new Error(`Ошибка в строке дат: ${datesString}`);

  const start = parse(datesArr[0], DATE_FORMAT, new Date());
  if (isNaN(getTime(start))) throw new Error(`Ошибка в дате старта: ${datesArr[0]}`);

  const end = parse(datesArr[1], DATE_FORMAT, new Date());
  if (isNaN(getTime(end))) throw new Error(`Ошибка в дате конца: ${datesArr[1]}`);

  return { start, end };
};
